// Note: 第三方服務、智慧行銷設定、API Key 設定
const thirdPartyServiceList = () =>
  import('@/pages/ThirdPartyService/ThirdPartyServiceList.vue');
const previewAndSenderSet = () =>
  import('@/pages/PreviewAndSender/PreviewAndSenderSet.vue');
const messageAutomationSet = () =>
  import('@/pages/MessageAutomation/MessageAutomationSet.vue');
  const appList = () => import('@/pages/ApiKeySet/AppList.vue');

export default {
  name: 'settings',
  meta: {
    key: 'settings',
  },
  path: '/settings',
  children: [
    {
      name: 'thirdPartyService',
      icon: 'ic_common_telepress',
      path: '/settings/third-party-service',
      meta: {
        permission: ['external_service'],
      },
      component: thirdPartyServiceList,
    },
    {
      name: 'smartMarketingSet',
      icon: 'ic_common_user_refresh',
      path: '/settings/smart-marketing-set',
      meta: {
        permission: ['settings'],
      },
      redirect: {
        name: 'previewAndSender',
      },
      children: [
        {
          name: 'previewAndSender',
          path: '/settings/smart-marketing-set/preview-and-sender',
          meta: {
            permission: ['settings'],
          },
          component: previewAndSenderSet,
        },
        {
          name: 'messageAutomation',
          path: '/settings/smart-marketing-set/message-automation',
          meta: {
            permission: ['settings'],
          },
          component: messageAutomationSet,
        },
      ],
    },
    {
      name: 'appKeySet',
      icon: 'ic_common_api',
      path: '/settings/users-management/app-key-set',
      meta: {
        permission: ['external_app'],
      },
      component: appList,
    },
  ],
};
